/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AnimalProgressValue } from '../models/animal-progress-value';
import { createAnimalProgressValue } from '../fn/medical-history/create-animal-progress-value';
import { CreateAnimalProgressValue$Params } from '../fn/medical-history/create-animal-progress-value';
import { createVisit } from '../fn/medical-history/create-visit';
import { CreateVisit$Params } from '../fn/medical-history/create-visit';
import { deleteAnimalProgressValue } from '../fn/medical-history/delete-animal-progress-value';
import { DeleteAnimalProgressValue$Params } from '../fn/medical-history/delete-animal-progress-value';
import { deleteVisit } from '../fn/medical-history/delete-visit';
import { DeleteVisit$Params } from '../fn/medical-history/delete-visit';
import { findAnimalProgressValuesByAnimalId } from '../fn/medical-history/find-animal-progress-values-by-animal-id';
import { FindAnimalProgressValuesByAnimalId$Params } from '../fn/medical-history/find-animal-progress-values-by-animal-id';
import { findById } from '../fn/medical-history/find-by-id';
import { FindById$Params } from '../fn/medical-history/find-by-id';
import { findStock } from '../fn/medical-history/find-stock';
import { FindStock$Params } from '../fn/medical-history/find-stock';
import { getByArticleIdTreatmentIds } from '../fn/medical-history/get-by-article-id-treatment-ids';
import { GetByArticleIdTreatmentIds$Params } from '../fn/medical-history/get-by-article-id-treatment-ids';
import { getPrescriptions } from '../fn/medical-history/get-prescriptions';
import { GetPrescriptions$Params } from '../fn/medical-history/get-prescriptions';
import { getVisitForAnimal } from '../fn/medical-history/get-visit-for-animal';
import { GetVisitForAnimal$Params } from '../fn/medical-history/get-visit-for-animal';
import { Prescription } from '../models/prescription';
import { SalesArticleStock } from '../models/sales-article-stock';
import { savePrescriptions } from '../fn/medical-history/save-prescriptions';
import { SavePrescriptions$Params } from '../fn/medical-history/save-prescriptions';
import { TreatmentInstruction } from '../models/treatment-instruction';
import { updateAnimalProgressValue } from '../fn/medical-history/update-animal-progress-value';
import { UpdateAnimalProgressValue$Params } from '../fn/medical-history/update-animal-progress-value';
import { updateVisit } from '../fn/medical-history/update-visit';
import { UpdateVisit$Params } from '../fn/medical-history/update-visit';
import { updateVisitBillable } from '../fn/medical-history/update-visit-billable';
import { UpdateVisitBillable$Params } from '../fn/medical-history/update-visit-billable';
import { Visit } from '../models/visit';
import { VisitCustomer } from '../models/visit-customer';

@Injectable({ providedIn: 'root' })
export class MedicalHistoryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findById()` */
  static readonly FindByIdPath = '/api/visits/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: FindById$Params, context?: HttpContext): Observable<StrictHttpResponse<VisitCustomer>> {
    return findById(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: FindById$Params, context?: HttpContext): Observable<VisitCustomer> {
    return this.findById$Response(params, context).pipe(
      map((r: StrictHttpResponse<VisitCustomer>): VisitCustomer => r.body)
    );
  }

  /** Path part for operation `updateVisit()` */
  static readonly UpdateVisitPath = '/api/visits/{id}';

  /**
   * Updates a medical history visit with the given id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateVisit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateVisit$Response(params: UpdateVisit$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateVisit(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates a medical history visit with the given id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateVisit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateVisit(params: UpdateVisit$Params, context?: HttpContext): Observable<void> {
    return this.updateVisit$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createVisit()` */
  static readonly CreateVisitPath = '/api/visits/{id}';

  /**
   * Creates a medical history visit with the given id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createVisit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createVisit$Response(params: CreateVisit$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createVisit(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a medical history visit with the given id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createVisit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createVisit(params: CreateVisit$Params, context?: HttpContext): Observable<void> {
    return this.createVisit$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteVisit()` */
  static readonly DeleteVisitPath = '/api/visits/{id}';

  /**
   * Deletes a medical history visit with the given id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteVisit()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteVisit$Response(params: DeleteVisit$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteVisit(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a medical history visit with the given id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteVisit$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteVisit(params: DeleteVisit$Params, context?: HttpContext): Observable<void> {
    return this.deleteVisit$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getPrescriptions()` */
  static readonly GetPrescriptionsPath = '/api/visits/{id}/prescriptions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPrescriptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPrescriptions$Response(params: GetPrescriptions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Prescription>>> {
    return getPrescriptions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPrescriptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPrescriptions(params: GetPrescriptions$Params, context?: HttpContext): Observable<Array<Prescription>> {
    return this.getPrescriptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Prescription>>): Array<Prescription> => r.body)
    );
  }

  /** Path part for operation `savePrescriptions()` */
  static readonly SavePrescriptionsPath = '/api/visits/{id}/prescriptions';

  /**
   * Saves treatment prescriptions by visit id.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `savePrescriptions()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  savePrescriptions$Response(params: SavePrescriptions$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return savePrescriptions(this.http, this.rootUrl, params, context);
  }

  /**
   * Saves treatment prescriptions by visit id.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `savePrescriptions$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  savePrescriptions(params: SavePrescriptions$Params, context?: HttpContext): Observable<void> {
    return this.savePrescriptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateVisitBillable()` */
  static readonly UpdateVisitBillablePath = '/api/visits/{id}/billable/{isBillable}';

  /**
   * Set all treatments to billable (or not) inside a medical history visit with the given id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateVisitBillable()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateVisitBillable$Response(params: UpdateVisitBillable$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateVisitBillable(this.http, this.rootUrl, params, context);
  }

  /**
   * Set all treatments to billable (or not) inside a medical history visit with the given id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateVisitBillable$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  updateVisitBillable(params: UpdateVisitBillable$Params, context?: HttpContext): Observable<void> {
    return this.updateVisitBillable$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateAnimalProgressValue()` */
  static readonly UpdateAnimalProgressValuePath = '/api/mh/animal-progress-value/{id}';

  /**
   * Updates an animal progress value with the given id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAnimalProgressValue()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAnimalProgressValue$Response(params: UpdateAnimalProgressValue$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateAnimalProgressValue(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an animal progress value with the given id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAnimalProgressValue$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAnimalProgressValue(params: UpdateAnimalProgressValue$Params, context?: HttpContext): Observable<void> {
    return this.updateAnimalProgressValue$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createAnimalProgressValue()` */
  static readonly CreateAnimalProgressValuePath = '/api/mh/animal-progress-value/{id}';

  /**
   * Creates an animal progress value with the given id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAnimalProgressValue()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAnimalProgressValue$Response(params: CreateAnimalProgressValue$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createAnimalProgressValue(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates an animal progress value with the given id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAnimalProgressValue$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAnimalProgressValue(params: CreateAnimalProgressValue$Params, context?: HttpContext): Observable<void> {
    return this.createAnimalProgressValue$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteAnimalProgressValue()` */
  static readonly DeleteAnimalProgressValuePath = '/api/mh/animal-progress-value/{id}';

  /**
   * Deletes an animal progress value with the given id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAnimalProgressValue()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAnimalProgressValue$Response(params: DeleteAnimalProgressValue$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteAnimalProgressValue(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes an animal progress value with the given id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAnimalProgressValue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAnimalProgressValue(params: DeleteAnimalProgressValue$Params, context?: HttpContext): Observable<void> {
    return this.deleteAnimalProgressValue$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getVisitForAnimal()` */
  static readonly GetVisitForAnimalPath = '/api/visits';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVisitForAnimal()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVisitForAnimal$Response(params: GetVisitForAnimal$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Visit>>> {
    return getVisitForAnimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getVisitForAnimal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVisitForAnimal(params: GetVisitForAnimal$Params, context?: HttpContext): Observable<Array<Visit>> {
    return this.getVisitForAnimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Visit>>): Array<Visit> => r.body)
    );
  }

  /** Path part for operation `findStock()` */
  static readonly FindStockPath = '/api/visits/stock';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findStock()` instead.
   *
   * This method doesn't expect any request body.
   */
  findStock$Response(params: FindStock$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleStock>>> {
    return findStock(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findStock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findStock(params: FindStock$Params, context?: HttpContext): Observable<Array<SalesArticleStock>> {
    return this.findStock$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SalesArticleStock>>): Array<SalesArticleStock> => r.body)
    );
  }

  /** Path part for operation `getByArticleIdTreatmentIds()` */
  static readonly GetByArticleIdTreatmentIdsPath = '/api/mh/treatment-instruction';

  /**
   * Returns treatment instruction for a treatment, if not found fetches drug instruction for article
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getByArticleIdTreatmentIds()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByArticleIdTreatmentIds$Response(params?: GetByArticleIdTreatmentIds$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TreatmentInstruction>>> {
    return getByArticleIdTreatmentIds(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns treatment instruction for a treatment, if not found fetches drug instruction for article
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getByArticleIdTreatmentIds$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByArticleIdTreatmentIds(params?: GetByArticleIdTreatmentIds$Params, context?: HttpContext): Observable<Array<TreatmentInstruction>> {
    return this.getByArticleIdTreatmentIds$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TreatmentInstruction>>): Array<TreatmentInstruction> => r.body)
    );
  }

  /** Path part for operation `findAnimalProgressValuesByAnimalId()` */
  static readonly FindAnimalProgressValuesByAnimalIdPath = '/api/mh/animal-progress-value/animal/{animalId}';

  /**
   * Returns the animal progress values by the given animal id.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAnimalProgressValuesByAnimalId()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAnimalProgressValuesByAnimalId$Response(params: FindAnimalProgressValuesByAnimalId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AnimalProgressValue>>> {
    return findAnimalProgressValuesByAnimalId(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns the animal progress values by the given animal id.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findAnimalProgressValuesByAnimalId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAnimalProgressValuesByAnimalId(params: FindAnimalProgressValuesByAnimalId$Params, context?: HttpContext): Observable<Array<AnimalProgressValue>> {
    return this.findAnimalProgressValuesByAnimalId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AnimalProgressValue>>): Array<AnimalProgressValue> => r.body)
    );
  }

}
